import React, { useContext } from 'react'
import type { Product } from './types'

const ProductContext = React.createContext<{ product: Product }>({ product: 'todoist' })

export function ProductProvider({
    children,
    product,
}: {
    children: React.ReactNode
    product: Product
}) {
    return <ProductContext.Provider value={{ product }}>{children}</ProductContext.Provider>
}

export function useProduct() {
    const { product } = useContext(ProductContext)

    if (!product) {
        throw new Error('useProduct must be within a ProductProvider')
    }

    return product
}
